import React from "react";
import { Modal, Button } from "react-bootstrap";
import { FiX } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import usePlan from "../hooks/usePlan";

// Single upgrade prompt replacing the three legacy modals (SubscriptionModal,
// exportPdfModal, MessagingUpgradeModal) — all of which displayed stale Pro
// pricing ($12.99 / $129.99). Same Bootstrap modal styling and tracking flow.
//
// Behaviour switch: users who haven't yet claimed their paid Pro Trial get a
// prominent "Start trial" primary CTA pointing at /trial; users who already
// used the trial get the regular "See plans" CTA and the trial offer is
// hidden (matches the locked "one trial per user" rule).
//
// Props:
//   show         — bool, controls visibility (same as legacy `show`)
//   onCancel     — fn, called when the user closes (same as legacy `onCancel`)
//   eventSource  — string, tracking key (same as legacy)
//   message      — optional override for the body text. Defaults to the
//                  Pro-feature message used by most callsites.
const PaywallSheet = ({
  show,
  onCancel,
  eventSource,
  message = "You need Pro to unlock this feature",
}) => {
  const navigate = useNavigate();
  const { isTrialEligible: trialEligible } = usePlan();

  const handleStartTrial = () => {
    onCancel && onCancel();
    navigate("/trial", { state: { source: eventSource } });
  };

  const handleUpgrade = () => {
    onCancel && onCancel();
    navigate("/profile/subscription", {
      state: { source: eventSource, defaultTab: "Pro" },
    });
  };

  const handleRefer = () => {
    onCancel && onCancel();
    navigate("/referral");
  };

  return (
    <Modal
      show={show}
      onHide={onCancel}
      centered
      backdrop="static"
      dialogClassName="custom-modal logout-modal subscription-action-modal"
    >
      <Modal.Header>
        <h5 className="modal-title">Subscription Required!</h5>
        <Button className="close-btn" onClick={onCancel}>
          <FiX size={24} />
        </Button>
      </Modal.Header>
      <Modal.Body>
        <p>{message}</p>

        {trialEligible && (
          <div className="action-content mt-1">
            <strong style={{ display: "inline-block", textAlign: "center", width: "100%" }}>Try Pro for 3 days — $2.99</strong>
            <p>Auto-converts to Pro Yearly $29.99/yr on day 4.</p>
          </div>
        )}

        <div className="action-content mt-1">
          <strong  style={{ display: "inline-block", textAlign: "center", width: "100%" }}>{trialEligible ? "Or pick a plan" : "Pick a plan"}</strong>
          <p>Pro Monthly · $2.99/mo</p>
          <p>Pro Yearly · $29.99/yr</p>
          <p>Pro + Newsletter · $4.99/mo or $49.99/yr</p>
        </div>

        <div className="actions">
          <Button className="btn btn-secondary" onClick={handleRefer}>
            Refer & Earn Pro
          </Button>
          {trialEligible ? (
            <Button className="btn btn-primary" onClick={handleStartTrial}>
              Start trial
            </Button>
          ) : (
            <Button className="btn btn-primary" onClick={handleUpgrade}>
              See plans
            </Button>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PaywallSheet;
